import React, { useState, useEffect, useCallback } from 'react';
import { FormHandles, SubmitHandler } from '@unform/core';
import { Form } from '@unform/web';

import api from '../../../services/api';

import Input from '../../../components/FormInput';
import Select from '../../../components/SelectForm';
import Button from '../../../components/Button';

import { Container, DivCombobox } from './styles';

interface Customer {
  customerId: number;
  name: string;
}

interface Project {
  name: string;
  customerId: number;
  customerName: string;
  browserTitle: string;
  buttonsColor: string;
  urlFavicon: string;
  overlayBoxColor: string;
  urlLogo: string;
  urlRadarChart: string;
  headerColor: string;
  heightLogo: string;

  headerImagePath?: string;
  headerImageId?: number;

  backgroundImagePath?: string;
  backgroundImageId?: number;

  hideProgressText?: boolean;
  showConfettiRain?: boolean;
}

interface Props {
  formRef: React.Ref<FormHandles>;
  buttonText: string;
  initialData?: Project;
  handleSubmit: SubmitHandler;
  customerData?: Customer;
}

interface SelectProps {
  value: number;
  label: string;
}

const FormProject: React.FC<Props> = props => {
  const [customers, setCustomers] = useState<SelectProps[]>();
  const [types, setTypes] = useState<SelectProps[]>();
  const [selectedCustomer, setSelectedCutomer] = useState<SelectProps>();

  const [styles, setStyles] = useState<SelectProps[]>();
  const [logos, setLogos] = useState<SelectProps[]>();
  const [images, setImages] = useState<SelectProps[]>();
  const [browserTitle, setBrowserTitle] = useState<string>('');
  const [urlFavicon, setUrlFavicon] = useState<string>('');
  const [buttonsColor, setButtonsColor] = useState<string>('');
  const [overlayBoxColor, setOverlayBoxColor] = useState<string>('');
  const [headerColor, setHeaderColor] = useState<string>('');
  const [urlLogo, setUrlLogo] = useState<string>('');
  const [headerImagePath, setHeaderImagePath] = useState<string | undefined>(
    '',
  );

  const [backgroundImagePath, setBackgroundImagePath] = useState<string>('');
  const [urlRadarChart, setUrlRadarChart] = useState<string>('');
  const [server, setServer] = useState<string>('');
  const [headerIsColor, setHeaderIsColor] = useState<boolean>(true);
  const [heightLogo, setHeightLogo] = useState<string>('');

  const [headerType, setHeaderType] = useState<SelectProps[]>();

  const [hideProgressText, setHideProgressText] = useState<boolean>(false);
  const [showConfettiRain, setShowConfettiRain] = useState<boolean>(false);

  useEffect(() => {
    if (props.initialData) {
      setSelectedCutomer({
        value: props.initialData.customerId,
        label: props.initialData.customerName,
      });

      setBrowserTitle(props.initialData.browserTitle);
      setUrlFavicon(props.initialData.urlFavicon);
      setButtonsColor(props.initialData.buttonsColor);
      setOverlayBoxColor(props.initialData.overlayBoxColor);
      setUrlLogo(props.initialData.urlLogo);
      setHeaderImagePath(props.initialData.headerImagePath);
      setUrlRadarChart(props.initialData.urlRadarChart);

      setHideProgressText(props.initialData.hideProgressText ?? false);
      setShowConfettiRain(props.initialData.showConfettiRain ?? false);

      if (props.initialData?.headerImagePath) {
        setHeaderImagePath(props.initialData.headerImagePath);
        setHeaderIsColor(false);

        const formRefLocal: React.Ref<FormHandles> = props.formRef;
        if (formRefLocal) {
          const formHandles: any = formRefLocal;
          formHandles.current?.setFieldValue('listHeadertype', {
            value: 2,
            label: 'Header with image',
          });
        }
      } else {
        setHeaderIsColor(true);
      }

      if (props.initialData?.backgroundImagePath) {
        setBackgroundImagePath(props.initialData.backgroundImagePath);
      }

      setHeaderColor(props.initialData.headerColor);
      setHeightLogo(props.initialData?.heightLogo);
    } else {
      setBrowserTitle('Emotion Banking');
      const prefix = process.env.NODE_ENV === 'development' ? 'http' : 'https';
      const serverFavicon = `${prefix}://${window.location.host}`;
      setUrlFavicon(`${serverFavicon}/favicon.ico`);
      if (server.includes('localhost') || server.includes('homolog')) {
        const pathLogo = `${server}/02f10d4fd7e0b20493ef-1_Logo%20ohne%20Unterschrift.png`;
        setUrlLogo(pathLogo);
        const logoDefault = {
          value: 34,
          label: pathLogo,
          filePath: pathLogo,
        };
        const formRefLocal: React.Ref<FormHandles> = props.formRef;
        if (formRefLocal) {
          const formHandles: any = formRefLocal;
          formHandles.current?.setFieldValue('logoId', logoDefault);
        }
      } else {
        const pathLogo = `${server}/c24a8a5d2b870b93865e-1_Logo%20ohne%20Unterschrift.png`;
        setUrlLogo(pathLogo);
        const logoDefault = {
          value: 44,
          label: pathLogo,
          filePath: pathLogo,
        };
        const formRefLocal: React.Ref<FormHandles> = props.formRef;
        if (formRefLocal) {
          const formHandles: any = formRefLocal;
          formHandles.current?.setFieldValue('logoId', logoDefault);
        }
      }
      setUrlRadarChart('/static/media/bg-radar-chart-pink.9da4933a.png');
      setButtonsColor('#FF780C');
      setOverlayBoxColor('#FF780C');

      setHeaderColor('#FF780C');
      setHeightLogo('100%');
    }

    const stylesDefault: any = [
      {
        value: 1,
        label: 'Selbsttest TSÖ',
      },
      {
        value: 2,
        label: 'Emotion Banking',
      },
      {
        value: 3,
        label: 'Spirit Hoch Drei',
      },
      {
        value: 4,
        label: 'Kunde21',
      },
    ];
    setStyles(stylesDefault);

    const HeaderTypeOptions: any = [
      {
        value: 1,
        label: 'Header with color',
      },
      {
        value: 2,
        label: 'Header with image',
      },
    ];
    setHeaderType(HeaderTypeOptions);

    api.get('logos').then(response => {
      setServer(`${response.request?.responseURL.replace('/logos', '/files')}`);
      setLogos(
        response.data.map((logo: any) => {
          return {
            value: logo.logoId,
            label: logo.originalname,
            filePath: `${response.request?.responseURL.replace(
              '/logos',
              '/files',
            )}/${logo?.filename}`,
          };
        }),
      );
    });

    api.get('images').then(response => {
      setServer(
        `${response.request?.responseURL.replace('/images', '/files')}`,
      );
      setImages(
        response.data.map((img: any) => {
          return {
            value: img.logoId,
            label: img.originalname,
            filePath: `${response.request?.responseURL.replace(
              '/images',
              '/files',
            )}/${img?.filename}`,
          };
        }),
      );
    });

    api.get('customers').then(response => {
      setCustomers(
        response.data.map((customer: Customer) => {
          return {
            value: customer.customerId,
            label: customer.name,
          };
        }),
      );
    });
    api.get('projectsTypes').then(response => {
      setTypes(response.data);
    });
  }, [props.formRef, props.initialData, server]);

  const handleTypeChange = useCallback(selectedValue => {
    setTypes(selectedValue);
  }, []);

  const handleBrowserTitleChange = useCallback(x => {
    setBrowserTitle(x.target.value);
  }, []);
  const handleUrlFaviconChange = useCallback(x => {
    setUrlFavicon(x.target.value);
  }, []);
  const handleButtonsColorChange = useCallback(x => {
    setButtonsColor(x.target.value);
  }, []);
  const handleOverlayBoxColorChange = useCallback(x => {
    setOverlayBoxColor(x.target.value);
  }, []);

  const handleHeaderColorChange = useCallback(x => {
    setHeaderColor(x.target.value);
  }, []);

  const handleHeightLogoChange = useCallback(x => {
    setHeightLogo(x.target.value);
  }, []);

  const handleLogoChange = useCallback(x => {
    setUrlLogo(x.filePath);
  }, []);

  const handleHeaderImageChange = useCallback(x => {
    setHeaderImagePath(x.filePath);
  }, []);

  const handleCustomerChange = useCallback((x: SelectProps) => {
    setSelectedCutomer(x);
  }, []);

  const handleBackgroundImageChange = useCallback(x => {
    if (x?.filePath) {
      setBackgroundImagePath(x.filePath);
    } else {
      setBackgroundImagePath('');
    }
  }, []);

  const handleUrlRadarChartChange = useCallback(x => {
    setUrlRadarChart(x.target.value);
  }, []);

  const handleHeaderTypeChange = useCallback(x => {
    if (x.value === 1) {
      setHeaderImagePath('');
      setHeaderIsColor(true);
    }

    if (x.value === 2) {
      setHeaderIsColor(false);
      setHeaderImagePath('');
    }
  }, []);

  const handleStylesChange = useCallback(
    selectedValue => {
      const prefix = process.env.NODE_ENV === 'development' ? 'http' : 'https';
      const serverFavicon = `${prefix}://${window.location.host}`;

      switch (selectedValue.value) {
        case 1: {
          setBrowserTitle('Selbsttest TSÖ');
          setUrlFavicon(`${serverFavicon}/favicontso.ico`);
          setUrlRadarChart('/static/media/bg-radar-chart-pink.9da4933a.png');
          setOverlayBoxColor('#b31c1d');
          setButtonsColor('#b31c1d');

          setHeaderColor('#b31c1d');
          setHeightLogo('100%');

          if (server.includes('localhost') || server.includes('homolog')) {
            const pathLogo = `${server}/f357c64e1ff3a5786bc4-Logo%20TS%C3%96%20transparenter%20HG.png`;
            setUrlLogo(pathLogo);
            const logoDefault = {
              value: 38,
              label: pathLogo,
              filePath: pathLogo,
            };

            const formRefLocal: React.Ref<FormHandles> = props.formRef;
            if (formRefLocal) {
              const formHandles: any = formRefLocal;
              formHandles.current?.setFieldValue('logoId', logoDefault);
            }
          } else {
            const pathLogo = `${server}/203e540f5dd20809256c-Logo%20TS%C3%96%20transparenter%20HG.png`;
            setUrlLogo(pathLogo);
            const logoDefault = {
              value: 41,
              label: pathLogo,
              filePath: pathLogo,
            };
            const formRefLocal: React.Ref<FormHandles> = props.formRef;
            if (formRefLocal) {
              const formHandles: any = formRefLocal;
              formHandles.current?.setFieldValue('logoId', logoDefault);
            }
          }

          break;
        }
        case 2: {
          setBrowserTitle('Emotion Banking');
          setUrlFavicon(`${serverFavicon}/favicon.ico`);
          setUrlRadarChart('/static/media/bg-radar-chart-pink.9da4933a.png');
          setButtonsColor('#FF780C');
          setOverlayBoxColor('#FF780C');

          setHeaderColor('#FF780C');
          setHeightLogo('100%');

          if (server.includes('localhost') || server.includes('homolog')) {
            const pathLogo = `${server}/02f10d4fd7e0b20493ef-1_Logo%20ohne%20Unterschrift.png`;
            setUrlLogo(pathLogo);
            const logoDefault = {
              value: 34,
              label: pathLogo,
              filePath: pathLogo,
            };
            const formRefLocal: React.Ref<FormHandles> = props.formRef;
            if (formRefLocal) {
              const formHandles: any = formRefLocal;
              formHandles.current?.setFieldValue('logoId', logoDefault);
            }
          } else {
            const pathLogo = `${server}/c24a8a5d2b870b93865e-1_Logo%20ohne%20Unterschrift.png`;
            setUrlLogo(pathLogo);
            const logoDefault = {
              value: 44,
              label: pathLogo,
              filePath: pathLogo,
            };
            const formRefLocal: React.Ref<FormHandles> = props.formRef;
            if (formRefLocal) {
              const formHandles: any = formRefLocal;
              formHandles.current?.setFieldValue('logoId', logoDefault);
            }
          }
          break;
        }
        case 3: {
          setBrowserTitle('Spirit Hoch');
          setUrlFavicon(`${serverFavicon}/faviconsp3.ico`);
          setUrlRadarChart('/static/media/bg-radar-chart-pink.9da4933a.png');
          setButtonsColor('#ed1e79');
          setOverlayBoxColor('#ed1e79');

          setHeaderColor('#ed1e79');
          setHeightLogo('100%');

          if (server.includes('localhost') || server.includes('homolog')) {
            const pathLogo = `${server}/529a8b0ac5e562ad7b3c-spirit-hoch.webp`;
            setUrlLogo(pathLogo);
            const logoDefault = {
              value: 30,
              label: pathLogo,
              filePath: pathLogo,
            };
            const formRefLocal: React.Ref<FormHandles> = props.formRef;
            if (formRefLocal) {
              const formHandles: any = formRefLocal;
              formHandles.current?.setFieldValue('logoId', logoDefault);
            }
          } else {
            const pathLogo = `${server}/529a8b0ac5e562ad7b3c-spirit-hoch.webp`;
            setUrlLogo(pathLogo);
            const logoDefault = {
              value: 30,
              label: pathLogo,
              filePath: pathLogo,
            };
            const formRefLocal: React.Ref<FormHandles> = props.formRef;
            if (formRefLocal) {
              const formHandles: any = formRefLocal;
              formHandles.current?.setFieldValue('logoId', logoDefault);
            }
          }

          break;
        }
        case 4: {
          setBrowserTitle('Kunde 21');
          setUrlFavicon(`${serverFavicon}/favicon-kunde21.ico`);
          setUrlRadarChart('/static/media/bg-radar-chart-pink.9da4933a.png');
          setButtonsColor('#00A19A');
          setOverlayBoxColor('#00A19A');
          setHeaderColor('#00A19A');
          setHeightLogo('100%');

          if (server.includes('localhost') || server.includes('homolog')) {
            const pathLogo = `${server}/5976efd805a020836612-logo-kunde21.png`;
            setUrlLogo(pathLogo);
            const logoDefault = {
              value: 41,
              label: pathLogo,
              filePath: pathLogo,
            };
            const formRefLocal: React.Ref<FormHandles> = props.formRef;
            if (formRefLocal) {
              const formHandles: any = formRefLocal;
              formHandles.current?.setFieldValue('logoId', logoDefault);
            }
          } else {
            const pathLogo = `${server}/881b5bb3790f53126ec9-K21%20wei%C3%9F.png`;
            setUrlLogo(pathLogo);
            const logoDefault = {
              value: 54,
              label: pathLogo,
              filePath: pathLogo,
            };
            const formRefLocal: React.Ref<FormHandles> = props.formRef;
            if (formRefLocal) {
              const formHandles: any = formRefLocal;
              formHandles.current?.setFieldValue('logoId', logoDefault);
            }
          }

          break;
        }
        default:
          setBrowserTitle('Victor Neu');
          setUrlFavicon(`${serverFavicon}/favicon.ico`);
          setUrlRadarChart('/static/media/bg-radar-chart-pink.9da4933a.png');
          setButtonsColor('#1ab394');
          setOverlayBoxColor('#1ab394');

          setHeaderColor('#1ab394');
          setHeightLogo('100%');

          if (server.includes('localhost') || server.includes('homolog')) {
            const pathLogo = `${server}/02f10d4fd7e0b20493ef-1_Logo%20ohne%20Unterschrift.png`;
            setUrlLogo(pathLogo);
            const logoDefault = {
              value: 34,
              label: pathLogo,
              filePath: pathLogo,
            };
            const formRefLocal: React.Ref<FormHandles> = props.formRef;
            if (formRefLocal) {
              const formHandles: any = formRefLocal;
              formHandles.current?.setFieldValue('logoId', logoDefault);
            }
          } else {
            const pathLogo = `${server}/c24a8a5d2b870b93865e-1_Logo%20ohne%20Unterschrift.png`;
            setUrlLogo(pathLogo);
            const logoDefault = {
              value: 44,
              label: pathLogo,
              filePath: pathLogo,
            };
            const formRefLocal: React.Ref<FormHandles> = props.formRef;
            if (formRefLocal) {
              const formHandles: any = formRefLocal;
              formHandles.current?.setFieldValue('logoId', logoDefault);
            }
          }
          break;
      }
    },
    [props.formRef, server],
  );

  const handleChangeHideProgressText = useCallback(() => {
    setHideProgressText(!hideProgressText);
  }, [hideProgressText]);

  const handleChangeShowConfettiRain = useCallback(() => {
    setShowConfettiRain(!showConfettiRain);
  }, [showConfettiRain]);

  return (
    <Container>
      <Form
        ref={props.formRef}
        initialData={props.initialData}
        onSubmit={props.handleSubmit}
      >
        <h2>Customer</h2>
        <Select
          name="customerId"
          options={customers}
          value={selectedCustomer}
          isDisabled={!!props.customerData || !!props.initialData}
          placeholder="Select customer"
          onChange={e => handleCustomerChange(e)}
        />

        <h2>Name</h2>
        <Input type="text" name="name" placeholder="Enter project name" />

        <h2>Type</h2>
        <Select
          name="type"
          options={types}
          onChange={e => handleTypeChange(e)}
        />

        <h2>Default Styles</h2>
        <Select
          name="listStylesDefault"
          options={styles}
          defaultValue={{ label: 'Emotion Banking', value: 2 }}
          onChange={e => handleStylesChange(e)}
        />

        <h2>Browser Title</h2>
        <Input
          type="text"
          name="browserTitle"
          value={browserTitle}
          placeholder="Enter title to display in browser tab"
          onChange={handleBrowserTitleChange}
        />

        <h2>Buttons color</h2>
        <Input
          type="color"
          name="buttonsColor"
          value={buttonsColor}
          onChange={handleButtonsColorChange}
        />

        <h2>Background Image</h2>
        <Select
          isClearable={true}
          name="backgroundImageId"
          options={images}
          onChange={e => handleBackgroundImageChange(e)}
          formatOptionLabel={img => (
            <div className="header-option">
              <img style={{ maxWidth: '45px' }} src={img.filePath} alt="img" />
              <span> {img.label}</span>
            </div>
          )}
        />
        <h2>OverlayBox color</h2>
        <Input
          type="color"
          name="overlayBoxColor"
          value={overlayBoxColor}
          onChange={handleOverlayBoxColorChange}
        />
        <h2>Logo</h2>
        <Select
          name="logoId"
          options={logos}
          onChange={e => handleLogoChange(e)}
          formatOptionLabel={logo => (
            <div className="logo-option">
              <img src={logo.filePath} alt="logo-image" />
              <span>{logo.label}</span>
            </div>
          )}
        />

        <h2>Size Logo </h2>
        <Input
          type="text"
          name="heightLogo"
          placeholder="Enter height logo"
          value={heightLogo}
          onChange={handleHeightLogoChange}
        />

        <h2>Header</h2>
        <Select
          name="listHeadertype"
          options={headerType}
          defaultValue={{ label: 'Header with color', value: 1 }}
          onChange={e => handleHeaderTypeChange(e)}
        />

        <div hidden={!headerIsColor}>
          <h2>Header color</h2>
          <Input
            type="color"
            name="headerColor"
            value={headerColor}
            onChange={handleHeaderColorChange}
          />
        </div>

        <div hidden={headerIsColor}>
          <h2>Header Image</h2>
          <Select
            name="headerImageId"
            options={images}
            onChange={e => handleHeaderImageChange(e)}
            formatOptionLabel={img => (
              <div className="header-option">
                <img src={img.filePath} alt="header-image" />
                <span>{img.label}</span>
              </div>
            )}
          />
        </div>

        <div hidden={true}>
          <h2>Url Logo</h2>
          <Input
            type="text"
            name="urlLogo"
            value={urlLogo}
            placeholder="Enter url logo to display in surveys"
            onChange={handleLogoChange}
          />

          <h2>Url Image</h2>
          <Input
            type="text"
            name="headerImagePath"
            value={headerImagePath}
            placeholder="Enter url image to display in surveys"
            onChange={handleHeaderImageChange}
          />

          <h2>background Image</h2>
          <Input
            type="text"
            name="backgroundImagePath"
            value={backgroundImagePath}
            placeholder="Enter url image to display in background"
            onChange={handleBackgroundImageChange}
          />

          <h2>Url Favicon</h2>
          <Input
            type="text"
            name="urlFavicon"
            placeholder="Enter url to display in browser tab"
            value={urlFavicon}
            onChange={handleUrlFaviconChange}
          />

          <h2>Url Radar Chart</h2>
          <Input
            type="text"
            name="urlRadarChart"
            value={urlRadarChart}
            placeholder="Enter url Radar Chart Image to display in analytics"
            onChange={handleUrlRadarChartChange}
          />
        </div>

        <DivCombobox>
          <Input
            id="cbProgressText"
            type="checkbox"
            checked={hideProgressText}
            onChange={handleChangeHideProgressText}
            name="hideProgressText"
            value={String(hideProgressText)}
            styled={false}
          />
          <span id="labelHideProgressText">Hide Progress text</span>

          <br />

          <Input
            id="cbShowConfettiRain"
            type="checkbox"
            checked={showConfettiRain}
            onChange={handleChangeShowConfettiRain}
            name="showConfettiRain"
            value={String(showConfettiRain)}
            styled={false}
          />
          <span id="labelShowConfettiRain">Show confetti rain when finish</span>
        </DivCombobox>

        <Button type="submit" $width="200px">
          {props.buttonText}
        </Button>
      </Form>
    </Container>
  );
};

export default FormProject;
